export const MuiFormHelperText = {
  styleOverrides: {
    root: {
      marginLeft: '0',
      marginTop: '5px',
      color: '#9A9AA3',
      fontSize: '12px',
      lineHeight: '12px',

      '&.Mui-error': {
        color: '#F44336',
      },
    },
  },
};
